import React from 'react'

const checkDoubleViewBox = (name) =>
  name.match(/(arrow).+(double)/g)
    ? name.match(/(left|right)/)
      ? '32 16'
      : '16 32'
    : '16 16'

const Icon = ({ name, className, events, ...props }) => {
  if (!name) name = 'noicon'
  return (
    <svg
      {...props}
      {...events}
      viewBox={`0 0 ${checkDoubleViewBox(name)}`}
      className={`ui gp-icon ${name.replace(/ /g, '-')} ${className}`}
    >
      <use xlinkHref={`#${name.replace(/ /g, '-')}`} />
    </svg>
  )
}

Icon.defaultProps = {
  className: ''
}

export default Icon
